import { render, staticRenderFns } from "./PricingLogic.vue?vue&type=template&id=704d7096"
import script from "./PricingLogic.vue?vue&type=script&lang=js"
export * from "./PricingLogic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports